// @ts-nocheck
import * as React from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import OrbcommLogo11 from '../../images/ORBCOMMLOGOR.svg';


interface State {
    copied: boolean;
    clipboardSupported: boolean;
}
export default class InitAuth extends React.Component<RouteComponentProps<{}>, any> {
    //window.location.href = "/"+sessionStorage.getItem("region")
   url: string;
    baseUrl: string;
    constructor(props: any) {
        super(props);
        this.state = {
            copied: false,
            clipboardSupported: !!navigator.clipboard,
             copyError: false,
        };
        //this.url = window.location.href;
        this.url = window.location.href;
        this.baseUrl = this.url.replace("/initAuth", "");
        var region = sessionStorage.getItem("region");
        if (region) {
            region = region.replace(/"/g, '');
            this.baseUrl = this.baseUrl + "/" + region;
        }
    var preloader = document.getElementById("preloader");
    preloader.classList.add("hidden");
    }

    handleButtonClick = () => {
        this.setState({ copied: true, copyError: false });
        var region = sessionStorage.getItem("region");
        if (region) {
            region = region.replace(/"/g, '');
            window.location.href = "/" + region;
            setTimeout(() => {
                this.url = window.location.href;
                window.open(this.url, '_self'); // Open the URL after the delay
            }, 6000);
        }
         
    };

    componentDidMount() {
        $('#globalLoader').hide();

    }

    public render() {
        return         <div>

            <div className="container">
              
                    <div className='login-main'>
                        <img src={OrbcommLogo11} alt="Maritime platform logo" className='region-logo' />
                        <span className='region-maritime'> MARITIME </span>
                    </div>
               
                <div className='alert alert-light login-text'> Your org now supports Multi-factor authentication (MFA) for the ORBCOMM Maritime platform </div>
                <p>{this.baseUrl}</p>
                {<p style={{ color: 'green' }}>Copy the above url then Press Ctrl+D (or Cmd+D on Mac) to bookmark.</p>}
               
                <div> <button type="button"  onClick={this.handleButtonClick} className="btn btn-primary mt-5"> Click here to bookmark the URL  </button></div>
                  
            </div>

            <div className='login-footer'><span>© ORBCOMM {(new Date().getFullYear())} All Rights Reserved</span></div>
        </div>
           }
}